import { useEffect, useState } from "react";
import {
  Button, Modal, ModalBody, ModalCloseButton, ModalContent,
  ModalFooter, ModalHeader, ModalOverlay, FormControl, FormLabel, Input,
} from "@chakra-ui/react";

export default function EditFileModal({
  OnSubmit = () => {},
  IsLoading = false,
  OnClose = () => {},
  IsOpen = false,
  FileData,
  texts = {} 
}) {
  const fileManagerTexts = texts?.fileManager || {};
  const generalTexts = texts?.general || {};
  
  const [nameWithoutExtension, setNameWithoutExtension] = useState("");
  const [fileExtension, setFileExtension] = useState("");

  useEffect(() => {
    if (IsOpen && FileData?.FileName) {
      const parts = FileData.FileName.split('.');
      if (parts.length > 1) {
        const extension = parts.pop();
        const name = parts.join('.');
        setNameWithoutExtension(name);
        setFileExtension(extension);
      } else {
        setNameWithoutExtension(FileData.FileName);
        setFileExtension("");
      }
    }
  }, [IsOpen, FileData]);

  const handleSubmit = async () => {
    const success = await OnSubmit({
      FileName: nameWithoutExtension,
      FileId: FileData.FileId,
      Tab: "EditFile",
    });

    if (success) {
      OnClose();
    }
  };

  return (
    <Modal isOpen={IsOpen} onClose={OnClose} isCentered>
      <ModalOverlay />
      <ModalContent as="form" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
        <ModalHeader>{fileManagerTexts.renameFile || "Rename File"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl isRequired>
            <FormLabel>{fileManagerTexts.newFileName || "New file name"}</FormLabel>
            <Input 
              value={nameWithoutExtension} 
              onChange={(e) => setNameWithoutExtension(e.target.value)} 
              autoFocus 
              onFocus={(e) => e.target.select()}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button 
            type="submit" 
            colorScheme="blue" 
            mr={3} 
            isLoading={IsLoading} 
            isDisabled={!nameWithoutExtension}
          >
            {generalTexts.saveChanges || "Save Changes"}
          </Button>
          <Button variant="ghost" onClick={OnClose}>
            {generalTexts.cancel || "Cancel"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}